import {shallowEqual, useSelector} from 'react-redux'

const useTranslator = () => {
  return useSelector((state) => state.translator, shallowEqual)
}

export default useTranslator
